import React from "react";
import Button from '../components/Button';
import SplitSection from '../components/SplitSection';
import pmdiquette from "../images/pmdiquette.png";
import louhei from "../images/louhei.png";
import snaplock from "../images/snaplock.png";

function ProjectSection({...props}) {
  return (
    <div {...props}>
      <SplitSection
        id="projects"
        primarySlot={
          <div className="">
            <div className="text-3xl font-bold my-2 object-center">Pmdiquette</div>
            <p className="block md:hidden">
              The world's first virtual reality-based Personal Mobility Device (PMD) training simulator.
            </p>
            <p className="hidden md:block">
              The world's first virtual reality-based Personal Mobility Device (PMD) training simulator that allows riders to practice their skills in a virtual environment.
            </p>
          </div>
        }
        secondarySlot={<img
          className="object-cover w-full h-60 object-left sm:object-contain sm:h-80 sm:object-center"
          src={pmdiquette}
          alt="pmdiquette"
        />}
      />
      <SplitSection
        id="projects"
        reverseOrder
        primarySlot={
          <div className="pr-5 sm:pr-7 lg:pr-9">
            <div className="text-3xl font-bold my-2 object-center ">Prosperity Toss</div>
            <p className="block md:hidden">
              A real-time multiplayer toss called "Lou Hei" performed during the Lunar New Year.
            </p>
            <p className="hidden md:block">
              A real-time multiplayer toss called "Lou Hei" performed during the Lunar New Year, where families and friends come together to toss up a good fortune.
            </p>
          <div className="my-8">
            <Button
              text="View it"
              newTab={true}
              href="https://master.d2hgyp77rn18ui.amplifyapp.com/welcome"
            />
          </div>
        </div>
        }
        secondarySlot={<img
          className="object-contain w-full h-60 sm:h-80 pr-5"
          src={louhei}
          alt="louhei"
        />}
      />
      <SplitSection
        id="projects"
        primarySlot={
          <div className="">
            <div className="text-3xl font-bold my-2 object-center">Snaplock</div>
            <p className="block md:hidden">
              A solution for a myriad of security products such as household locks and commercial locks.
            </p>
            <p className="hidden md:block">
              A solution for a myriad of security products such as household locks and commercial locks to cater to different business scenarios. This one-stop IoT development platform offers integration and cloud services.
            </p>
          </div>
        }
        secondarySlot={<img
          className="object-cover w-full h-40 object-left sm:object-contain sm:h-80 sm:object-center"
          src={snaplock}
          alt="snaplock"
        />}
      />
    </div>
  );
}

export default ProjectSection;